import { pushCtaEvent } from '@utils/dataLayer';
import {
  getAnalyticsContextFromElement,
  getAnalyticsItemMetaFromElement,
  getAnalyticsSection,
} from '@utils/analyticsContext';

const CTA_SELECTOR = [
  '.c-button',
  '[data-concierge-cta]',
  'a[href$="/concierge"]',
  'a[href$="/concierge/"]',
  'a[href*="signup"]',
  'a[data-track-click]',
  'button[data-track-click]',
].join(',');

const MANUAL_CTA_SELECTOR = [
  '.media-basic-text__cta',
  '.hero-landing__button',
  '.decanter-detail__discover-collection',
  '.decanter-detail__inquire_to_purchase',
  '.decanter-detail__how-to-register',
  '.digital-cellar__discover-collection',
  '.certificate-registration__wrapper .auth-form__register-link[data-sso-state]',
  '#email-login',
  '#searchOwnership',
].join(',');

const getCtaLabel = (element) => element.getAttribute('data-concierge-cta')
  || element.getAttribute('data-label')
  || element.getAttribute('aria-label')
  || element.textContent.trim();

const handleCtaClick = (event) => {
  const target = event.target?.closest?.(CTA_SELECTOR);

  if (!target || target.matches(MANUAL_CTA_SELECTOR)) {
    return;
  }

  const itemMeta = getAnalyticsItemMetaFromElement(target);

  pushCtaEvent({
    ...itemMeta,
    section: getAnalyticsSection() || document.title || '',
    context: getAnalyticsContextFromElement(target),
    label: getCtaLabel(target),
  });
};

const initCtaTracking = () => {
  document.addEventListener('click', handleCtaClick);
};

export default initCtaTracking;
